export const buildApplicationFormBody = (sid, formValues) => ({
  contact: {
    name: formValues.contactName,
    email: formValues.contactEmail,
    role:
      formValues.contactRole === "Other"
        ? formValues.contactRoleCustom
        : formValues.contactRole,
  },
  school: {
    sid,
    name: formValues.schoolName,
    type:
      formValues.schoolType === "Other"
        ? formValues.schoolTypeCustom
        : formValues.schoolType,
    trustName: formValues.schoolTrust !== "" ? formValues.schoolTrust : null,
    numberOfStudents: parseInt(formValues.schoolNumberOfStudents),
    percentageFreeSchoolMeals: Math.round(
      parseFloat(formValues.schoolPercentageFreeSchoolMeals),
    ),
    numberOfMathsTeachers: parseInt(formValues.schoolNumberOfMathsTeachers),
  },
  other: {
    rateRequested: parseFloat(formValues.rateRequested),
    otherInformation:
      formValues.otherInformation !== "" ? formValues.otherInformation : null,
  },
});

const isString = (str) => {
  return typeof str === "string";
};

const isNonEmptyString = (str) => {
  return isString(str) && str !== "";
};

const stringIsPositiveInteger = (str) => {
  return isNonEmptyString(str) && !isNaN(parseInt(str)) && parseInt(str) >= 0;
};

const stringIsPositiveFloat = (str) => {
  return (
    isNonEmptyString(str) && !isNaN(parseFloat(str)) && parseFloat(str) >= 0
  );
};

export function getValidationMethod(property) {
  switch (property) {
    case "contactName":
    case "contactEmail":
    case "contactRole":
    case "schoolName":
    case "schoolType": {
      return (values) => isNonEmptyString(values[property]);
    }
    case "schoolTrust":
    case "otherInformation": {
      return (values) => isString(values[property]);
    }
    case "contactRoleCustom": {
      return (values) =>
        values.contactRole === "Other"
          ? isNonEmptyString(values.contactRoleCustom)
          : isString(values.contactRoleCustom);
    }
    case "schoolTypeCustom": {
      return (values) =>
        values.schoolType === "Other"
          ? isNonEmptyString(values.schoolTypeCustom)
          : isString(values.schoolTypeCustom);
    }
    case "schoolNumberOfStudents":
    case "schoolNumberOfMathsTeachers": {
      return (values) => stringIsPositiveInteger(values[property]);
    }
    case "schoolPercentageFreeSchoolMeals": {
      return (values) =>
        stringIsPositiveFloat(values[property]) &&
        parseFloat(values[property]) <= 100;
    }
    case "rateRequested": {
      return (values) =>
        ["0.5", "0.75"].includes(values.rateRequested) ||
        (values.schoolType === "Specialist" && values.rateRequested === "0.25");
    }
  }
}
